<main class="wrapper">
    <app-privacy-content></app-privacy-content>
</main>